import React, { Component } from 'react'
import {injectStripe} from 'react-stripe-elements'
import SpinnerUI from '../../widgets/output/SpinnerUI'
import ButtonUI from '../../widgets/action/ButtonUI'
import MessageUtils from '../../util/MessageUtils'
import ButtonLinkUI from '../../widgets/action/ButtonLinkUI'
import ErrorMessageUI from '../../widgets/form/ErrorMessageUI'
import SuccessMessageUI from '../../widgets/form/SuccessMessageUI'
import InputTextSF from '../../widgets/form/InputTextSF'
import InputFieldUI from '../../widgets/form/InputFieldUI'
import InputSelectUI from '../../widgets/form/InputSelectUI'
import CreditCard from '../../widgets/input/CreditCard'
import PriceViewUI from '../accountSettings/subscription/PriceViewUI'
import './CreditCardForm.css'

// https://stripe.com/docs/recipes/elements-react
class CreditCardForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }

    this.onSubmit = this.onSubmit.bind(this)
  }

  render() {
    return (
      <div className="cona_acc_crt_f">
        <SuccessMessageUI successMsg={this.props.successMsg} />
        <ErrorMessageUI errorList={this.props.errorList} />

        <InputTextSF type='text' name='accountName' required={true}
          messageList={this.props.messageList} labelKey='c_account_name'
          value={this.props.accountName} onChange={this.props.onAccountNameChange}
          error={this.props.accountNameError}
        />

        <InputSelectUI name='countryCode' required={true}
          messageList={this.props.messageList} labelKey='c_country'
          value={this.props.countryCode} optionList={this.props.countryList}
          onChange={this.props.onCountryCodeChange} error={this.props.countryCodeError}
        />

        <InputFieldUI messageList={this.props.messageList} labelKey='c_plan' helpKey='c_create_account_tip'>
          <div className='price_list'>
            {
              this.props.priceList && this.props.priceList.map((price, i) =>
                <PriceViewUI key={i} context={this.props.context} messageList={this.props.messageList}
                  price={price} selectedPriceId={this.props.priceId}
                  selectMode={true} onSelect={this.props.onPriceIdChange}
                />
              )
            }
          </div>
        </InputFieldUI>

        <InputFieldUI messageList={this.props.messageList} labelKey='c_credit_card'>
          <CreditCard context={this.props.context} />
        </InputFieldUI>

        {/*
        <InputTextSF type='text' name='nameOnCard' required={true}
          messageList={this.props.messageList} labelKey='label_name_on_card'
          value={this.state.nameOnCard} onChange={this.state.onNameOnCardChange}
          error={this.props.accountNameError}
        />
        */}

        <div className='action g_flex_h'>
          <ButtonLinkUI
            messageList={this.props.messageList}
            labelKey='c_cancel'
            transparent={true}
            to='/settings/user/teams' />
          <SpinnerUI show={this.props.submitted} />
          <ButtonUI
            messageList={this.props.messageList}
            labelKey='c_create'
            onClick={this.onSubmit}
            disabled={this.state.submitted} />
        </div>
      </div>
    )
  }

  async onSubmit(ev) {
    let submitted = this.state.submitted
    if (submitted)
      return

    let errorList = []
    // validate account name
    if (!this.props.accountName.trim()) {
      let labelMessage = MessageUtils.getMessageValue(this.props.messageList, 'c_account_name')
      let errorMessage = MessageUtils.getMessageValue(this.props.messageList, 'c_required_field', [labelMessage])
      this.props.setAccountNameError(errorMessage)
      errorList.push(errorMessage)
    }

    // vaidate card
    let token = await this.props.stripe.createToken(/*{name: "Name"}*/)
    console.log(token)
    if (token.error) {
      // e.g.:
      // type: "validation_error", code: "incomplete_number", message: "Your card number is incomplete."
      // TODO localize
      errorList.push(token.error.message)
    }

    if (errorList.length > 0) {
      this.props.setErrorList(errorList)
      return
    }

    this.props.onSubmit(token)
  }
}

export default injectStripe(CreditCardForm)
